import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList } from '@fortawesome/pro-solid-svg-icons';

import AddCallListOption from './add_call_list';

const CallListOption = (props) => {
  const { data, innerProps, innerRef, label } = props;

  if (data.type === 'addCallListItem') return <AddCallListOption {...props} />;

  return (
    <div ref={innerRef} {...innerProps} className="entity" name="call-list">
      <FontAwesomeIcon
        className="type-icon"
        icon={faList}
        pull="left"
        size="lg"
      />
      <strong>{label}</strong>
    </div>
  );
};

CallListOption.propTypes = {
  data: PropTypes.shape({
    type: PropTypes.string
  }).isRequired,
  innerProps: PropTypes.object,
  innerRef: PropTypes.object,
  label: PropTypes.string.isRequired
};

export default CallListOption;
